import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type UseQueryResult } from "@tanstack/react-query";

import {
  type BookabilityStatusRequest,
  bookabilityStatusRequestSchema,
  type BookabilityStatusResponse,
  bookabilityStatusResponseSchema,
} from "../types";

export type BookabilityStatusParams = Omit<BookabilityStatusRequest, "shiftIds"> & {
  shiftIds: string[];
};

export const GET_BOOKABILITY_STATUS_PATH = "/bookability-status";
export const GET_BOOKABILITY_STATUS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}${GET_BOOKABILITY_STATUS_PATH}`;

export function useBookabilityStatus(
  params: BookabilityStatusParams,
  options: UseGetQueryOptions<BookabilityStatusResponse> = {}
): UseQueryResult<BookabilityStatusResponse> {
  const { workerId, shiftIds, returnFirstUnmetCriteria = true } = params;

  const queryParams: BookabilityStatusRequest = {
    workerId,
    shiftIds: shiftIds.join(","),
    returnFirstUnmetCriteria,
  };

  return useGetQuery({
    url: GET_BOOKABILITY_STATUS_URL,
    queryParams,
    requestSchema: bookabilityStatusRequestSchema,
    responseSchema: bookabilityStatusResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_BOOKABILITY_STATUS_FAILURE,
    },
    ...options,
  });
}
